import firebase from "firebase/compat/app";

export default async function isUserPremium() {
  await firebase.auth().currentUser?.getIdToken(true);
  const decodedToken = await firebase.auth().currentUser?.getIdTokenResult();
  const claims = decodedToken?.claims || {};
  if (claims.premium === true) return claims.stripeRole ?? "premium";
  return claims.stripeRole;
}
